import draftToHtml from 'draftjs-to-html';
import { convertToRaw } from 'draft-js';
// eslint-disable-next-line import/no-extraneous-dependencies

const errorCheckText = (value) => {
  if (!value || value.length === 0) return '入力してください';
  return '';
};

const errorCheckDraft = (value) => {
  const draftContent = convertToRaw(value.getCurrentContent());
  const html = draftToHtml(draftContent);
  if (html.trim() === '<p></p>') return '入力してください';
  return '';
};

const errorCheckSelectList = (value) => {
  if (!value || !value.id) return '選択してください';
  return '';
};

// ANDがFalseかつORがTrueになる場合➾どちらかしか入力されていない場合
const errorCheckSendAt = (data) => {
  const { sendDate, sendHour } = data;
  return !(sendDate && sendHour) && (sendDate || sendHour);
};

class validation {
static formValidate = (type, value) => {
  switch (type) {
    case 'mstStore':
      return errorCheckSelectList(value);
    case 'title':
    case 'subject':
      return errorCheckText(value);
    case 'body':
      return errorCheckDraft(value);
    default:
      return '';
  }
};

static validateSendAt = (data) => errorCheckSendAt(data);
}

export default validation;
